import React from "react";
import { MetricsBentoBox } from "@/components/MetricsBentoBox";
import { OrganizationMetricsContextEnum } from "@/__generated__/types";
import { MessageCircle, Mail, UserRound, TrendingUp } from "lucide-react";
import { EngagementChart } from "./EngagementChart";
import { useTranslation } from "react-i18next";

export const Engagement = () => {
  const { t } = useTranslation();

  return (
    <div>
      <MetricsBentoBox
        loadingCount={4}
        metric={OrganizationMetricsContextEnum.Engagement}
        showTitle={true}
        title={t("adoption.bentosEngagement.title")}
        display={{
          groupChats: { icon: MessageCircle, color: "orange" },
          directMessage: { icon: Mail, color: "violet" },
          profileView: { icon: UserRound, color: "lime" },
          feedPostView: { icon: TrendingUp, color: "yellow" },
        }}
      />
      <h2 className="mt-6 mb-2 text-sm leading-5 font-normal text-muted-foreground">
        {t("engagement.chartSectionTitle")}
      </h2>
      <div className="mb-6 grid grid-cols-1 gap-6 lg:grid-cols-2">
        <EngagementChart
          title={t("engagement.charts.groupChats")}
          seriesType="groupChats"
          interval="monthly"
        />
        <EngagementChart
          title={t("engagement.charts.directMessages")}
          seriesType="directMessages"
          interval="monthly"
        />
        <EngagementChart
          title={t("engagement.charts.profileViews")}
          seriesType="profileViews"
          interval="monthly"
        />
        <EngagementChart
          title={t("engagement.charts.feedPostViews")}
          seriesType="feedPostViews"
          interval="monthly"
        />
        <EngagementChart
          title={t("engagement.charts.channelOpens")}
          seriesType="channelOpens"
          interval="monthly"
        />
        <EngagementChart
          title={t("engagement.charts.roommateMatch")}
          seriesType="roommateMatchFriendFinderSearches"
          interval="monthly"
        />
      </div>
    </div>
  );
};
